import { Component } from '@angular/core';

@Component({
  selector: 'app-meter-edit',
  template: ``,
  styleUrls: []
})
export class MeterEditComponent {

}
